/* screens/support/UserSupportChat.jsx — раздел «Поддержка» авторизованного
   пользователя: список СВОИХ заявок + переписка. Доступен любому авторизованному
   (без support_access). Deep-link /support?ticket=ID (кнопка из TG) авто-откроет
   нужную заявку. Логику несёт общий SupportTicketsPanel. */
import React from 'react';
import { PageHeader } from '../../components/patterns/PageHeader.jsx';
import { RR } from '../../lib/router.jsx';
import { SupportTicketsPanel } from './SupportTicketsPanel.jsx';

const { useSearchParams } = RR;

function UserSupportChat() {
  const [params] = useSearchParams();
  const ticket = params.get('ticket');

  return (
    <div className="section-page">
      <PageHeader subtitle="Ваши обращения в поддержку" title="Поддержка" />
      <div className="section-body">
        <SupportTicketsPanel autoOpenId={ticket} />
      </div>
    </div>
  );
}

export { UserSupportChat };
